/// <amd-module name="SuiteCommerce.StockNotifications.Checkout"/>
define("SuiteCommerce.StockNotifications.Checkout", ["require", "exports", "SuiteCommerce.StockNotifications.Header", "SuiteCommerce.StockNotifications.Configuration"], function (require, exports, Header, Configuration_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            Configuration_1.Configuration.environment = container.getComponent('Environment');
            Header.mountToApp(container);
        }
    };
});
